export default __webpack_public_path__ + "static/media/speedometer.ea6fcca7.png";